export default {
  sendNewActivity(activityId, siebelId) {
    const postMessage = {
      type: 'CREATE_APPEAL',
      from: 'OMNI',
      to: 'CCX',
      payload: {
        chatId: activityId,
      },
    };
    if (siebelId) postMessage.payload.contactId = siebelId;
    window.parent.postMessage(JSON.stringify(
      postMessage,
    ), '*');
  },
  sendLoginSuccess() {
    window.parent.postMessage(JSON.stringify(
      {
        type: 'LOGIN_DONE',
        from: 'OMNI',
        to: 'CCX',
      },
    ), '*');
  },
  sendLogoutSuccess() {
    window.parent.postMessage(JSON.stringify(
      {
        type: 'LOGOUT',
        from: 'OMNI',
        to: 'CCX',
      },
    ), '*');
  },
  sendOpenCardMsg(activityId, siebelId, appealId) {
    const postMessage = {
      type: 'OPEN_CONTACT_CARD',
      from: 'OMNI',
      to: 'CCX',
      payload: {
        chatId: activityId,
        appealId,
      },
    };
    if (siebelId) postMessage.payload.contactId = siebelId;
    window.parent.postMessage(JSON.stringify(
      postMessage,
    ), '*');
  },
  sendViewModeMsg(mode, width, height) {
    const payload = mode === 'MINI' ? { mode, width, height } : { mode };
    window.parent.postMessage(JSON.stringify(
      {
        type: 'SET_VIEW_MODE',
        from: 'OMNI',
        to: 'CCX',
        payload,
      },
    ), '*');
  },
  sendActivityDirectories(activityId, appealId, directories) {
    window.parent.postMessage(JSON.stringify(
      {
        type: 'CLOSE_APPEAL',
        from: 'OMNI',
        to: 'CCX',
        payload: {
          chatId: activityId,
          appealId,
          steps: directories,
        },
      },
    ), '*');
  },
  sendRedirectAppealMsg(activityId, siebelId, appealId) {
    const postMessage = {
      type: 'REDIRECT_APPEAL',
      from: 'OMNI',
      to: 'CCX',
      payload: {
        chatId: activityId,
        appealId,
      },
    };
    if (siebelId) postMessage.payload.contactId = siebelId;
    window.parent.postMessage(JSON.stringify(
      postMessage,
    ), '*');
  },
  sendIncomingRedirectAppealMsg(activityId, siebelId, appealId) {
    const postMessage = {
      type: 'INCOMING_REDIRECT_APPEAL',
      from: 'OMNI',
      to: 'CCX',
      payload: {
        chatId: activityId,
        appealId,
      },
    };
    if (siebelId) postMessage.payload.contactId = siebelId;
    window.parent.postMessage(JSON.stringify(
      postMessage,
    ), '*');
  },
};
